<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kEvBUZ/tc-custom/9781613735589.jpg?1720018430915" alt="This image is the cover for the book Roads"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Roads
      </h1>
      <p class="bookDescription body article font2">
        <p>When Nazi forces occupy the beautiful coastal city of Yalta, Crimea, everything changes. Eighteen-year-old Filip has few options; he is a prime candidate for forced labor in Germany. His hurried marriage to his childhood friend Galina might grant him reprieve, but the rules keep shifting. Galina’s parents, branded as traitors for innocently doing business with the enemy, decide to volunteer in hopes of better placement. The work turns out to be horrific, but at least the family stays together. By winter 1945, Allied air raids destroy strategic sites; Dresden, a city of no military consequence, seems safe. The world knows Dresden’s fate. Roads is the story of one family lucky enough to escape with their lives as the city burns behind them. But as the war ends, they are separated and their trials continue. Looking for safety in an alien land, they move toward one another with the help of refugee networks and pure chance. Along the way, they find new ways to live in a changed world—new meanings for fidelity, grief, and love.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marina Antropow Cramer
      </h2>
      
      <p class="authorDescription body article">Marina Antropow Cramer is a writer whose work has appeared in Blackbird, Istanbul Literary Review, and Wilderness House Literary Review. Roads is her first novel. She lives in Slate Hill, New York.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chicago Review Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7b206f0a